import { AfterViewInit, Directive, ElementRef, inject, Input, OnDestroy } from '@angular/core';

@Directive({
    selector: '[stbyAutofocus]',
})
export class AutofocusDirective implements AfterViewInit, OnDestroy {
    private el = inject(ElementRef);

    private _autofocus = true;
    private observer: MutationObserver;

    @Input('stbyAutofocus')
    set autofocus(value: boolean) {
        this._autofocus = value !== false && value !== null && value !== undefined;
    }

    ngAfterViewInit() {
        if (!this._autofocus) return;

        setTimeout(() => {
            if (!this.el.nativeElement.hidden) {
                this.el.nativeElement.focus();
            }

            // Create a MutationObserver to observe changes in the "hidden" attribute on the element
            this.observer = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'hidden') {
                        if (!this.el.nativeElement.hidden) {
                            this.el.nativeElement.focus();
                        }
                    }
                }
            });

            this.observer.observe(this.el.nativeElement, { attributes: true });
        }, 100);
    }

    ngOnDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }
}
